export default "__VITE_ASSET__715a4759__"